export const tagData = [
  {
    part_code: 'AHCAAJH4000-B2501-0A',
    customer_name: 'Hero Motors',
    part_name: "Piece R End'",
    bin_type: 'A',
    bin_size: '400X300X120',
    qty: 70,
  },
  {
    part_code: 'AHC00000042-B2504-00',
    customer_name: 'Hero Motors',
    part_name: 'Piece L End 1',
    bin_type: 'A',
    bin_size: '400X300X120',
    qty: 70,
  },
  {
    part_code: 'AHCAFF00000-B2531-00',
    customer_name: 'Hero Motors',
    part_name: 'Piece R End AAFF',
    bin_type: 'A',
    bin_size: '400X300X120',
    qty: 50,
  },
  {
    part_code: 'AHCAFF00000-B2532-00',
    customer_name: 'Hero Motors',
    part_name: 'Piece L End AAFF',
    bin_type: 'A',
    bin_size: '400X300X120',
    qty: 50,
  },
  {
    part_code: 'AHCAAF0026-B15007-00',
    customer_name: 'Hero Motors',
    part_name: 'Bar Tread Main Stand AAFF',
    bin_type: 'A',
    bin_size: '400X300X120',
    qty: 100,
  },
  {
    part_code: 'AHC198900H010100601',
    customer_name: 'Hero Motors',
    part_name: "STAY 'A' CHAIN CASE",
    bin_type: 'A',
    bin_size: '400X300X120',
    qty: 750,
  },
  {
    part_code: 'AHCAAF0034-B15015-00',
    customer_name: 'Hero Motors',
    part_name: 'Extended Clip Main Stand AAFF',
    bin_type: 'A',
    bin_size: '400X300X120',
    qty: 500,
  },
  {
    part_code: 'AHCAANB100-B25005-00',
    customer_name: 'Hero Motors',
    part_name: 'Stay Stopper Arm AANN',
    bin_type: 'A',
    bin_size: '400X300X120',
    qty: 350,
  },
  {
    part_code: 'AHCAAF40003-B2538-00',
    customer_name: 'Hero Motors',
    part_name: 'Guide Chain Case AAFF',
    bin_type: 'A',
    bin_size: '400X300X120',
    qty: 750,
  },
  {
    part_code: 'AHCAAN100-B25011-00',
    customer_name: 'Hero Motors',
    part_name: 'Stay Brk Spring- AANN',
    bin_type: 'A',
    bin_size: '400X300X120',
    qty: 1500,
  },
  {
    part_code: 'AHCAANB100-B25007-00',
    customer_name: 'Hero Motors',
    part_name: 'Brkt Brake Rod Support-AANN',
    bin_type: 'A',
    bin_size: '400X300X120',
    qty: 500,
  },
  {
    part_code: 'AHCAAH0130H151104901',
    customer_name: 'Hero Motors',
    part_name: 'Main Plate KST',
    bin_type: 'A',
    bin_size: '400X300X120',
    qty: 200,
  },
  {
    part_code: 'AHCACK00002-B2599-00',
    customer_name: 'Hero Motors',
    part_name: 'Cross Member-ACK',
    bin_type: 'B',
    bin_size: '400X300X270/275',
    qty: 40,
  },
  {
    part_code: 'AHCACK00272-B1511-00',
    customer_name: 'Hero Motors',
    part_name: 'Tube Stand Tread(0145.9*1.6T)',
    bin_type: 'B',
    bin_size: '400X300X270/275',
    qty: 200,
  },
  {
    part_code: 'AHCAAF0005-B15009-00',
    customer_name: 'Hero Motors',
    part_name: 'Plate Stopper Main Stand AAFF',
    bin_type: 'B',
    bin_size: '400X300X270/275',
    qty: 500,
  },
  {
    part_code: 'AHC0000000H151100501',
    customer_name: 'Hero Motors',
    part_name: 'PIPE CROSS KSTG',
    bin_type: 'B',
    bin_size: '400X300X270/275',
    qty: 200,
  },
  {
    part_code: 'AHCAAF00313-B2536-00',
    customer_name: 'Hero Motors',
    part_name: 'Automated field',
    bin_type: 'B',
    bin_size: '400X300X270/275',
    qty: 400,
  },
];
